module.exports = __webpack_public_path__ + "34ea03da47a7bc13735137f2bba7974c.png";